// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsPartNumberStyles {
    labelText?: TypographyProps;
    valueText?: TypographyProps;
    // XNG-Change
    wrapper?: InjectableCss;
}

export const partNumberStyles: ProductDetailsPartNumberStyles = {
    labelText: {
        size: 16,
        weight: "bold",
        css: css`
            margin-right: 15px;
        `,
    },
    valueText: {
        size: 16,
        css: css`
            margin-bottom: 5px;
        `,
    },
};

const styles = partNumberStyles;

const ProductDetailsPartNumber: React.FC<Props> = ({ product }) => {
    if (!product.productNumber) {
        return null;
    }

    // XNG-Change: change translate and update structure
    return (
        <Typography {...styles.wrapper} data-test-selector="ProductDetailsPartNumber">
            <Typography {...styles.labelText}>{translate("Item #")}</Typography>
            <Typography {...styles.valueText}>{product.productNumber}</Typography>
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsPartNumber),
    definition: {
        displayName: "Part Number",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
